import { render, staticRenderFns } from "./BatchOptimization.vue?vue&type=template&id=7f8dd0dc&scoped=true"
import script from "./BatchOptimization.vue?vue&type=script&lang=js"
export * from "./BatchOptimization.vue?vue&type=script&lang=js"
import style0 from "./BatchOptimization.vue?vue&type=style&index=0&id=7f8dd0dc&prod&lang=less"
import style1 from "./BatchOptimization.vue?vue&type=style&index=1&id=7f8dd0dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8dd0dc",
  null
  
)

export default component.exports